module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/meditation-on-beach_720px-f3937d0eadb489ae36bad0bf1260dc16.jpeg";